// src/monogram.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var MonogramIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "current",
    fillRule: "evenodd",
    d: "M12.638 18.072a.559.559 0 0 1-1.12 0 5.522 5.522 0 0 0-5.517-5.513.559.559 0 1 1 0-1.118 5.522 5.522 0 0 0 5.518-5.513.56.56 0 0 1 1.119 0 5.522 5.522 0 0 0 5.517 5.513H21.6C21.31 6.407 17.119 2.4 12.009 2.4c-5.299 0-9.61 4.307-9.61 9.6 0 5.294 4.311 9.6 9.61 9.6 5.11 0 9.3-4.007 9.59-9.041h-3.444a5.522 5.522 0 0 0-5.517 5.513Z",
    clipRule: "evenodd"
  }
) });

export {
  MonogramIcon
};
